export const earningsStates = {
  assigned: {
    workerLabel: "Job reserved",
    adminLabel: "Assigned",
    tone: "info",
  },
  worker_arrived: {
    workerLabel: "Arrival confirmed",
    adminLabel: "Worker arrived",
    tone: "info",
  },
  work_started: {
    workerLabel: "Work in progress",
    adminLabel: "Work started",
    tone: "active",
  },
  work_completed: {
    workerLabel: "Work submitted",
    adminLabel: "Completion claimed",
    tone: "watch",
  },
  verification_hold: {
    workerLabel: "Final checks in progress",
    adminLabel: "Verification hold",
    tone: "watch",
  },
  secured: {
    workerLabel: "Earnings secured",
    adminLabel: "Secured",
    tone: "good",
  },
  partially_secured: {
    workerLabel: "Partially secured",
    adminLabel: "Partially secured",
    tone: "watch",
  },
  dispute_under_review: {
    workerLabel: "Issue review in progress",
    adminLabel: "Dispute under review",
    tone: "risk",
  },
  payout_scheduled: {
    workerLabel: "Transfer queued",
    adminLabel: "Payout scheduled",
    tone: "info",
  },
  payout_processing: {
    workerLabel: "Transfer being sent",
    adminLabel: "Payout processing",
    tone: "info",
  },
  paid: {
    workerLabel: "Transferred",
    adminLabel: "Paid",
    tone: "good",
  },
  reversed: {
    workerLabel: "Adjusted after closure",
    adminLabel: "Reversed",
    tone: "risk",
  },
  frozen: {
    workerLabel: "Account needs verification",
    adminLabel: "Frozen",
    tone: "risk",
  },
  clawback_required: {
    workerLabel: "Recovery required",
    adminLabel: "Clawback required",
    tone: "risk",
  },
  settlement_failed: {
    workerLabel: "Transfer could not be completed",
    adminLabel: "Settlement failed",
    tone: "risk",
  },
  payout_retrying: {
    workerLabel: "We are retrying your transfer",
    adminLabel: "Payout retrying",
    tone: "watch",
  },
};

export const walletBuckets = [
  "visible_earnings",
  "secured_earnings",
  "withdrawable_balance",
  "scheduled_for_transfer",
  "recovery_due",
];

export function getEarningsStateMeta(state) {
  return earningsStates[state] || {
    workerLabel: "Status updated",
    adminLabel: state || "Unknown",
    tone: "info",
  };
}
